import React,{useEffect,useState} from 'react';
// ,useContext
//import ReactTooltip from 'react-tooltip';
import {  Col, Modal, Button, Form } from 'react-bootstrap';
// , Nav, Tabs, Tab, FormCheck, FormControl, InputGroup, Dropdown, DropdownButton, SplitButton, Container, Row,
import { user_entity_uuid, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// searchUrl, org_uuid,
// import { grabFromLocalStorage, facebook_get_access_token_api, HeaderConfig, user_Registration, user_authentication, twitter_api } from 'Api/Api';

// import { local_routes } from "utils/Routes";

import { saveKey, getKey } from "utils/Helper";


import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';

import axios from "axios";



//import Facebook from 'containers/SocialLogin/Facebook/Facebook';
//import Twitter from 'containers/SocialLogin/Twitter/Twitter';
//import LinkedIn from 'containers/SocialLogin/LinkedIn/LinkedIn';
//import Google from 'containers/SocialLogin/Google/Google';


import './style.css';

function VerificationModal (props) {
  const [verification_code, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(<span>&nbsp;</span>);
  
  // on mount
  useEffect(() => {
    console.log("VerificationModal useEffect props.show");
  }, [props.show]);

  function checkForEnter (event) {
    //console.log("checkForEnter",event.key);
    setMessage(<span>&nbsp;</span>);
    if (event.key === 'Enter') {
      handleSubmitVerificationCode();
    }
  }

  function myChangeHandler (event) {
    //console.log("myChangeHandler",event.key);
    if (event.target.value.length > 6) {
      return; 
    }
    if (event.target.id === "verification_code") {
      setVerificationCode(event.target.value);
    }
  }

  async function getSetUpdatedUserData () {
      // Here calling GET User API
      let user_response = await axios.get(`${apiUrl}users/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
          
      let apiRes = user_response.data;
      let user_data = getKey("UserData");
      let updated_user_data = {
        UserMail: null,
        login_Auth_Res: {
          access_token: user_data.login_Auth_Res.access_token,
          expTime: user_data.login_Auth_Res.expTime,
          user_uuid: user_data.login_Auth_Res.user_uuid,
          access_level: apiRes.access_level,
          account_level: apiRes.account_level || 'normal',
          status_code: apiRes.status_code
        }
      };
      saveKey("UserData", JSON.stringify(updated_user_data));    
  }

  // Email Verify Submit
  async function handleSubmitVerificationCode () {
    
    console.log("Trying to submit verification_code",verification_code);
    if (verification_code.length < 6 || verification_code.length > 6) {
      console.log("verification_code bad length!",verification_code.length);
      setMessage(<span className="Invalid-Msg">Please enter exactly 6 digits</span>);
      //this.setState({ InvalidMsg: 3 })
      return;
    }

    setLoading(true);
    setMessage(<span>&nbsp;</span>);
    //this.setState({ accountOtpLoader: true, InvalidMsg: 0 })
    //let otpData = { "verification_token": this.state.otp }
    try {
      let post_obj = {
        verification_token: verification_code
      }
      //let verify_response = await axios.post(`${user_API}/${user_entity_uuid}/verifyEmail`, JSON.stringify(otpData), myHeaders_Authorized)
      let verify_response = await axios.post(`${apiUrl}users/${user_entity_uuid}/verifyEmail`, post_obj);
      // success
      //this.setState({ accountOtpLoader: false, InvalidMsg: 1 })
      setMessage(<span className="Valid-Msg">Verified Successfully</span>);
      //setLoading(false);
    
      saveKey("UserData", JSON.stringify({login_Auth_Res: verify_response.data}));
      
      /*
      this.setState({
        loading: true,
        reloading: true,
        validatedOtp: true,
        accountOtpLoader: false,
        InvalidMsg: 1
      });
      */
      return;
      
    } catch (err) {
      if (err['status'] === 403 && err.data && err.data.message && err.data.message.startsWith('user not in unverified state')) {
        console.log("User already verified!");
        setMessage(<span className="Valid-Msg">Already Verified</span>);
        setLoading(false);
        await this.getSetUpdatedUserData();
        /*
        this.setState({ accountOtpLoader: false, InvalidMsg: 1 })
        await this.getSetUpdatedUserData();
        this.setState({
          //userName,
          loading: true,
          reloading: true,
          validatedOtp: true,
          accountOtpLoader: false,
          InvalidMsg: 1
        });
        */
        return;
      } else {
        console.log("Verification failed for some reason",err);
        setMessage(<span className="Invalid-Msg">Invalid Verification Code! Please double check the code and try again</span>);
        //setVerificationCode('');
        setLoading(false);
        
        //this.setState({ accountOtpLoader: false, InvalidMsg: 2 })
        return;
      }
    }


  };
  
  /*
  // invalid messages for otp
  messageOtp = () => {
    const { InvalidMsg } = this.state;
    return (
      <div style={{ display: this.state.InvalidMsg === 0 ? "none" : null }} className="Invalid-section resend-msg">
        {
          InvalidMsg === 1 ?
            <span className="Valid-Msg">Verified Successfully</span>
            :
            InvalidMsg === 2 ?
              <span className="Invalid-Msg">Invalid Verification Code! Please double check the code and try again</span>
              :
              InvalidMsg === 3 ?
              <span className="Invalid-Msg">Please enter exactly 6 digits</span>
              : null
        }
      </div>
    )
  }
  */
  
  // OTP Resend Api starts here
  async function handleResendVerificationEmail () {
    setLoading(true);
    setMessage(<span>&nbsp;</span>);
    //this.setState({ accountResendLoader: true })
    let resendBody = {}
    //this.setState({ InvalidResendMsg: null });
    try {
      
      let post_obj = {};
      
      await axios.post(`${apiUrl}users/${user_entity_uuid}/resendVerificationEmail`, post_obj);
      
      setLoading(false);
      setMessage(<span className="Valid-Msg">Verification code successfully sent</span>);
      
      //this.setState({ accountResendLoader: false, InvalidResendMsg: 'Verification code successfully sent' });
    } catch (err) {
      console.log("ERROR",err);
      if (err['status'] === 429) {
        setLoading(false);
        setMessage(<span className="Invalid-Msg">Verification email recently sent; please wait 2 hours before trying again</span>);
        
        //this.setState({ accountResendLoader: false, InvalidResendMsg: 'Verification email recently sent; please wait some time before trying again' });
      } else if (err['status'] === 403 && err.data && err.data.message && err.data.message.startsWith('User has already verified their email')) {
        console.log("User already verified!");
        setMessage(<span className="Valid-Msg">Already Verified</span>);
        setLoading(false);
        await this.getSetUpdatedUserData();
        /*
        await this.getSetUpdatedUserData();
        this.setState({
          //userName,
          loading: true,
          reloading: true,
          validatedOtp: true,
          accountOtpLoader: false,
          InvalidMsg: 1
        });        
        */
        //this.setState({ accountResendLoader: false, InvalidResendMsg: 'Email already verified! Please logout and re-login and enjoy PechaKucha.com!' });
      } else {
        // should normally never happen
        console.log("Verification failed for some reason",err);
        setMessage(<span className="Invalid-Msg">Something went wrong: {err.response.data.message}</span>);
        setLoading(false);
        //this.setState({ accountResendLoader: false, InvalidResendMsg: 'ERROR: '+err.response.data.message });        
      }
    }
  };
  
  /*
  function messageResend () {
    const { InvalidResendMsg } = this.state;
    return (
      <div style={{ display: !this.state.InvalidResendMsg ? "none" : null }} className="Invalid-section resend-msg">
        {InvalidResendMsg}
      </div>
    )
  }
  */
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="text-center emailVerifyContainer"
    >
      <Modal.Header
        closeButton
        className="modal-containerData"
      >
        <span>Confirm your email</span>
        <p>Just enter the 6-digit code we sent to your email and you're done!</p>
      </Modal.Header>
      
      <Modal.Body className="otpContainer">
          <React.Fragment>
            <Form.Group as={Col} md="8" controlId="verification_code" className="mx-auto">
              <Form.Control
                disabled={loading}
                required
                type="number"
                value={verification_code}
                onChange={myChangeHandler}
                onKeyPress={checkForEnter}
                placeholder="123456"
              />
            </Form.Group>
            { loading &&
              <ActivityIndicator theme="button-Status-Loader" />
            }
            {message}  
            <div className="text-center modalButtons">
              <Button
                disabled={loading}
                onClick={handleSubmitVerificationCode}
                variant="pkprimary"
              >
                Confirm Email
              </Button>
            </div>
            
            <div className="otpModalBtn">
              <Button
                disabled={loading}
                onClick={handleResendVerificationEmail}
                variant="pkprimary"
              >
                Resend Verification Email
              </Button>
            </div>
            
          </React.Fragment>
        
      </Modal.Body>
    </Modal>
  );
  
  
/*
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}

      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <p style={{ textAlign: 'center' }}>Sign-Up!</p>

          <p style={{ textAlign: 'center', fontSize: "60%", color: "darkgray" }}>Watch thousands of PechaKucha presentations and get access to PK Create Basic for free.</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        
        <Container>
          <Row>
            <Col>
            <Nav justify variant="tabs" activeKey={tab_choice} onSelect={(k) => changeTab(k)}>
              <Nav.Item>
                <Nav.Link eventKey="signup">Sign Up</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="login">Log In</Nav.Link>
              </Nav.Item>
            </Nav>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col xs="12" sm="7">
                  <Form noValidate validated={email_password_validated} onSubmit={loginOrSignup}>
                    <fieldset disabled={loading}>
                    <Form.Row>
                      <Form.Group as={Col} controlId="validationEmail">
                          <Form.Label>E-MAIL ADDRESS</Form.Label>
                          <Form.Control
                              required
                              type="email"
                              placeholder="Enter your email"
                              onChange={myChangeHandler}
                          />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="validationPassword">
                          <Form.Label>PASSWORD</Form.Label>
                          <InputGroup>
                            <Form.Control
                                type={password_field_options.field_type}
                                placeholder="Enter your password"
                                aria-describedby="inputGroupPrepend"
                                required
                                onChange={myChangeHandler}
                            />
                            <span className="password-trigger" onClick={changePasswordVisibility}>{password_field_options.visibility_icon}</span>
                          </InputGroup>
                      </Form.Group>
                    </Form.Row>
                  
              { tab_choice === 'login' ?
                <Row className="">
                  <span style={{ marginTop: "-15px", marginLeft: "15px", fontSize: "smaller" }}><a target='_blank' href={local_routes.sendresetpasswordemail}>Forgot your password?</a></span>
                </Row>
                :
                <Row>
                  <span style={{ marginTop: "-15px", marginLeft: "15px", fontSize: "smaller" }}>&nbsp;</span>
                </Row>
              }
              <Row className="">
                <Col>
                  <Button type="submit" style={{ marginTop: "5px", width: "100%" }} className="modal_button">{tab_messaging[tab_choice].button_text}</Button>
                </Col>
              </Row>
              </fieldset>
              </Form>
            </Col>
            { loading ?
              <Col className="align-self-center" xs="12" sm="5">
              </Col>
              :
              <Col className="align-self-center" xs="12" sm="5">
                <Row className="d-xs-block d-sm-none" >
                  <Col>
                    <p style={{ textAlign: 'center', fontSize: "90%", fontWeight: "90%", fontStyle: 'italic' }}>- or -</p>
                  </Col>
                </Row>
                <Row className="d-none d-sm-block mt-4" >
                  <Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Facebook />
                  </Col>
                </Row>
                <Row className="mt-2" >
                  <Col>
                    <Google />
                  </Col>
                </Row>
                <Row className="mt-2" >
                  <Col>
                    <Twitter callbackUrl="/login" />
                  </Col>
                </Row>
                <Row className="mt-2" >
                  <Col>
                    <LinkedIn />
                  </Col>
                </Row>
              </Col>
            }
          </Row>
          <Row>
            <Col>
              {message}
            </Col>
          </Row>
          <Row className="">
            <span style={{ marginTop: "5px", marginLeft: "15px", marginRight: "15px", fontSize: "smaller" }}>By clicking above, I agree to the <a target='_blank' href="/termsofuse">Terms of Use</a> and have read the <a target='_blank' href="/privacypolicy">Privacy Statement</a>.</span>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button className="modal_button_white" onClick={props.onHide}>Maybe Later</Button>
      </Modal.Footer>
    </Modal>
  );
  */
}

export default VerificationModal;